<ion-select
  [label]="'common.constructionSite' | translate"
  label-placement="floating"
  fill="outline"
  (ionChange)="handleClick($event.detail.value)"
  [multiple]="multiple"
  [value]="preselectedConSite"
  mode="md"
  interface="popover"
  [interfaceOptions]="popoverOptions"
>
  @if (showAllEntry) {
  <ion-select-option [value]="null">{{
    "constructionSites.all" | translate
  }}</ion-select-option>
  } @for (conSite of this.activeConSites$ | async; track conSite) {
  <ion-select-option
    [value]="conSite.id"
    [disabled]="
      blackList?.includes(conSite.id) && conSite.id != this.selectedConSite
    "
    >{{ conSite.name }}</ion-select-option
  >
  }
</ion-select>
